import { Component } from 'solid-js'

const Divider: Component = () => (
  <div class="my-4 border-b border-[var(--bg-700)]" aria-hidden="true" />
)

export default Divider
